export const newsletterThemeTemplateQueryKeys = {
  _base: () => ["newsletterThemeTemplates"],
  byThemeId: (themeId: string) => [
    ...newsletterThemeTemplateQueryKeys._base(),
    "theme",
    themeId,
  ],
};

